import { Reducer, AnyAction } from 'redux';

export interface ReCaptchaState {
  v2Token: string;
}

export const initialState: ReCaptchaState = {
  v2Token: null as string
};

export const recaptchaReducer: Reducer<ReCaptchaState> = (state = initialState, action: AnyAction) => {
  switch (action.type) {
    case 'RECAPTCHA_V2_SUBMITTED':
      return { ...state, v2Token: action.payload };
    case 'GENERATE_ROTP_TOKEN_SUCCESS':
    case 'SUBMIT_PAYMENT_SUCCESS':
      return { ...state, ...initialState };
    default:
      return state;
  }
};
